"use client";

import { useFormikContext } from "formik";

import Input from "@client/components/formik/input";

interface Props {
  max?: number;
  name: string;
  id: string;
}

export default function FormikCurrency({ max, name, id }: Props) {
  const { setFieldValue } = useFormikContext();

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue(
      name,
      Number(e.target.value.replaceAll(/[^0-9]/g, "")).toLocaleString(),
    );
  };

  const maxLength = max ? max.toLocaleString("en-US").length : undefined;

  return (
    <div className="flex gap-2">
      <span>$</span>
      <Input
        id={id}
        name={name}
        inputMode="numeric"
        className="flex-1"
        onChange={handleOnChange}
        maxLength={maxLength}
      />
    </div>
  );
}
